import { useRef, useState } from "react";
import { RotateCcw } from "lucide-react";

/** Signature tactile du chauffeur (canvas) — renvoie une image PNG en data URL. */
export default function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  const point = (e) => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    const t = e.touches?.[0] || e;
    return [(t.clientX - r.left) * (c.width / r.width), (t.clientY - r.top) * (c.height / r.height)];
  };
  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.strokeStyle = "#0f172a";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(...point(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...point(e));
    ctx.stroke();
    setEmpty(false);
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange?.(empty ? null : ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange?.(null);
  };

  return (
    <div data-testid={testid}>
      <canvas ref={ref} width={600} height={180}
        className="w-full h-32 rounded-xl bg-white touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[11px] text-white/50">{empty ? "Signez dans le cadre blanc" : "Signature enregistrée"}</span>
        <button type="button" onClick={clear} data-testid="signature-clear"
          className="text-[11px] text-white/60 flex items-center gap-1 underline">
          <RotateCcw className="w-3 h-3" /> Effacer
        </button>
      </div>
    </div>
  );
}
